import { render, staticRenderFns } from "./BuscarReferidosComponent.vue?vue&type=template&id=a210cc52"
import script from "./BuscarReferidosComponent.vue?vue&type=script&lang=js"
export * from "./BuscarReferidosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports